export function routeForBasePath(basePath: string, clientId: string): string {
  // Handle empty or invalid basePath
  if (!basePath || typeof basePath !== "string") {
    return `/clients/${clientId}/edit`;
  }

  // Handle specific path patterns
  if (basePath.startsWith("client.profile")) return `/clients/${clientId}/edit/parties/client`;
  if (basePath.startsWith("client.exProfile")) return `/clients/${clientId}/edit/parties/ex`;
  if (basePath.startsWith("client.address")) return `/clients/${clientId}/edit/parties/client`;
  if (basePath.startsWith("client.children")) return `/clients/${clientId}/edit/children`;
  if (basePath.startsWith("client.parties")) return `/clients/${clientId}/edit/parties`;
  
  // Default fallback for unknown paths - always return a valid route
  return `/clients/${clientId}/edit`;
}

export function isCounselPath(basePath: string): boolean {
  if (!basePath) return false;
  return basePath.startsWith("client.lawyer");
}

export function isCourtPath(basePath: string): boolean {
  if (!basePath) return false;
  return basePath.startsWith("client.court");
}
